export const ratePlansTab = {
  sectionLabel: {
    title: "Tarife in der Direktbuchung",
    hintHotel:
      "Legen Sie fest, welche Tarife pro Zimmertyp erscheinen, in welcher Reihenfolge und welcher der Standardtarif ist.",
    hintApartment:
      "Legen Sie fest, welche Tarife der Gast sieht, ordnen Sie sie per Drag-and-drop und markieren Sie den Standardtarif.",
  },
  loading: "Tarife werden geladen…",
  empty: {
    apartment: "Für diese Unterkunft sind keine Tarife eingerichtet.",
    hotel: "Für dieses Hotel sind keine Zimmertypen eingerichtet.",
    room: "Für dieses Zimmer sind keine Tarife eingerichtet.",
  },
  derivedPill: "Abgeleitet",
  dragHandleTitle: "Zum Sortieren ziehen",
  visibleSwitchTitle: "In der Direktbuchung anzeigen",
  expandTitleClose: "Einstellungen schließen",
  expandTitleOpen: "Name, Bedingungen und Standard festlegen",
  visibleNameLabel: "Anzeigename",
  visibleNamePlaceholderApartment: "Z. B. Nicht erstattbar / Flexibel",
  visibleNamePlaceholderHotel: "Z. B. Inkl. Frühstück",
  cond: {
    refundable: "Stornierbar",
    refundableHint: "Sie entscheiden, bis wann es kostenlos ist.",
    nonRefundable: "Nicht erstattbar",
    nonRefundableHint: "Es wird nichts erstattet. Gäste können trotzdem stornieren, zahlen aber 100 %. Sie sehen das vor der Zahlung.",
    freeDays: "Kostenlose Stornierung bis",
    freeDaysPlaceholder: "Ohne Frist",
    freeDaysHelp: "Tage vor der Anreise. Leer = bis zur Anreise kostenlos.",
    penalty: "Danach berechnen Sie",
    penaltyHelp: "Vom Gesamtpreis des Aufenthalts. 100% = keine Rückerstattung.",
    sinGuardar: "Für diesen Tarif sind noch keine Bedingungen gespeichert. Unten steht ein Vorschlag — auf „Richtlinie speichern“ tippen, um ihn zu übernehmen.",
    aplicarTodas: "Auf alle Zimmer anwenden",
    aplicarTodasHelp: "Dieselbe Bedingung wird beim Tarif „{name}“ von 1 weiteren Zimmer gesetzt. | Dieselbe Bedingung wird beim Tarif „{name}“ von {count} weiteren Zimmern gesetzt.",
    notes: "Hinweise für den Gast (optional)",
    previewNonRefundable: "Der Gast liest: „Dieser Tarif ist nicht erstattbar: Die Buchung kann nicht storniert werden.“",
    previewFree: "Der Gast liest: „Kostenlose Stornierung bis zur Anreise.“",
    previewDayPenalty: "Der Gast liest: „Kostenlose Stornierung bis zum Anreisetag; danach werden {pct}% berechnet.“",
    previewUntilPenalty: "Der Gast liest: „Kostenlos bis 1 Tag vorher; danach werden {pct}% berechnet.“ | Der Gast liest: „Kostenlos bis {count} Tage vorher; danach werden {pct}% berechnet.“",
    shortNonRefundable: "Nicht erstattbar",
    shortFree: "Kostenlose Stornierung",
    shortDayPenalty: "Kostenlos bis zur Anreise · danach {pct}%",
    shortUntilPenalty: "Kostenlos bis 1 Tag vorher · danach {pct}% | Kostenlos bis {count} Tage vorher · danach {pct}%",
  },
  cancellationPolicyLabel: "Stornierungsbedingungen",
  policyEmpty: "Keine Bedingungen festgelegt",
  policyEdit: "Bearbeiten",
  policyAdd: "Hinzufügen",
  defaultLabel: "Standard",
  rulesApartment: "Regeln: mindestens 1 sichtbarer Tarif und 1 Standardtarif (der sichtbar sein muss).",
  rulesRoom: "Jedes Zimmer braucht mindestens 1 sichtbaren Tarif und 1 Standardtarif.",
  tip: 'Tipp: Legen Sie einen Tarif „Flexibel“ als Standard fest und zeigen Sie andere als „Nicht erstattbar“ an.',
  room: {
    ratePlansCount: "{count} Tarif | {count} Tarife",
    includedGuestsTitle: "Wie viele Gäste im Preis enthalten sind (für den Aufpreis pro Zusatzgast)",
    includes: "Enthält",
    person: "Gast | Gäste",
    meta: "Kapazität: {capacity} • Erwachsene: {adults} • Kinder: {children}",
  },
  modal: {
    eyebrow: "Stornierungsbedingungen",
    closeAria: "Schließen",
    hint: "Dieser Text wird dem Gast in der Direktbuchung angezeigt. Beschreiben Sie die Stornierungsbedingungen für diesen Tarif.",
    textareaPlaceholder:
      "Z. B. Kostenlose Stornierung bis 48 Std. vor dem Check-in. Danach wird die erste Nacht berechnet. In der Hochsaison nicht erstattbar.",
    clear: "Leeren",
    cancel: "Abbrechen",
    saving: "Wird gespeichert…",
    save: "Bedingungen speichern",
    defaultTitle: "Tarif",
  },
  toasts: {
    loadError: "Die Tarife konnten nicht geladen werden.",
    saveSuccess: "Tarife erfolgreich gespeichert.",
    saveError: "Die Tarife konnten nicht gespeichert werden.",
  },
  validation: {
    roomMinVisible: 'Zimmer „{name}“ braucht mindestens 1 sichtbaren Tarif.',
    roomOneDefault: 'Zimmer „{name}“ braucht genau 1 Standardtarif.',
    roomDefaultVisible: 'In „{name}“ muss der Standardtarif sichtbar sein.',
    minVisible: "Es muss mindestens 1 sichtbarer Tarif bleiben.",
    oneDefault: "Es muss genau 1 Standardtarif geben.",
    defaultVisible: "Der Standardtarif muss sichtbar sein.",
  },
};
